"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var react_1 = __importDefault(require("react"));
var SocialMediaWidget_1 = __importDefault(require("../../../utils/fabric/Widgets/SocialMedia/SocialMediaWidget"));
var IframeWidget_1 = __importDefault(require("../../../utils/fabric/Widgets/Iframe/IframeWidget"));
var StopScheduleWidget_1 = __importDefault(require("../../../utils/fabric/Widgets/StopSchedule/StopScheduleWidget"));
var VideoWidget_1 = __importDefault(require("../../../utils/fabric/Widgets/Video/VideoWidget"));
var DateWidget_1 = __importDefault(require("../../../utils/fabric/Widgets/Date/DateWidget"));
var MediaCarouselWidget_1 = __importDefault(require("../../../utils/fabric/Widgets/MediaCarousel/MediaCarouselWidget/MediaCarouselWidget"));
var QRCodeWidget_1 = __importDefault(require("../../../utils/fabric/Widgets/QRCode/QRCodeWidget"));
var RssFeedWidget_1 = __importDefault(require("../../../utils/fabric/Widgets/RssFeed/RssFeedWidget"));
var TableWidget_1 = __importDefault(require("../../../utils/fabric/Widgets/Table/TableWidget"));
var WeatherWidget_1 = __importDefault(require("../../../utils/fabric/Widgets/Weather/WeatherWidget"));
var FalconyAnnouncementsWidget_1 = __importDefault(require("../../../utils/fabric/Widgets/FalconyAnnouncements/FalconyAnnouncementsWidget"));
var DateElement_1 = __importDefault(require("./Elements/DateElement"));
var IframeElement_1 = __importDefault(require("./Elements/IframeElement"));
var StopScheduleElement_1 = __importDefault(require("./Elements/StopScheduleElement"));
var TableElement_1 = __importDefault(require("./Elements/TableElement"));
var VideoElement_1 = __importDefault(require("./Elements/VideoElement"));
var WeatherElement_1 = __importDefault(require("./Elements/WeatherElement"));
var RssFeedElement_1 = __importDefault(require("./Elements/RssFeedElement"));
var MediaCarouselElement_1 = __importDefault(require("./Elements/MediaCarouselElement"));
var QRCodeElement_1 = __importDefault(require("./Elements/QRCodeElement"));
var PlayerWidgetContainer_1 = __importDefault(require("./Elements/PlayerWidgetContainer"));
var CanvasBackground_1 = __importDefault(require("./CanvasBackground"));
/** Generate styles for content containers if content does not fit to the screen orientation */
var generateContenContainerStyles = function (screenResolutionWidth, screenResolutionHeight, _a) {
    var contentWidth = _a.width, contentHeight = _a.height;
    // Calculate scaling factors
    var scaleX = screenResolutionWidth / contentWidth;
    var scaleY = screenResolutionHeight / contentHeight;
    // Determine the minimum scale factor to maintain aspect ratio
    var scale = Math.min(scaleX, scaleY);
    // Calculate the scaled dimensions of the inner div
    var scaledContentWidth = contentWidth * scale;
    var scaledContentHeight = contentHeight * scale;
    // Calculate the position to center the inner div
    var leftPosition = (screenResolutionWidth - scaledContentWidth) / 2;
    var topPosition = (screenResolutionHeight - scaledContentHeight) / 2;
    // Styles for the outer div
    var rootStyle = {
        position: 'relative',
        width: "".concat(screenResolutionWidth, "px"),
        height: "".concat(screenResolutionHeight, "px")
    };
    // Styles for the inner div
    var contentStyle = {
        position: 'absolute',
        top: "".concat(topPosition, "px"),
        left: "".concat(leftPosition, "px"),
        width: "".concat(contentWidth, "px"),
        height: "".concat(contentHeight, "px"),
        transform: "scale(".concat(scale, ")"),
        transformOrigin: 'top left',
        overflow: 'hidden'
    };
    return {
        rootStyle: rootStyle,
        contentStyle: contentStyle
    };
};
/**
 * Component for playing canvas content
 */
var CanvasContent = function (_a) {
    var content = _a.content, screenResolutionWidth = _a.screenResolutionWidth, screenResolutionHeight = _a.screenResolutionHeight;
    var resolution = content.resolution, objects = content.canvas.objects;
    var _b = generateContenContainerStyles(screenResolutionWidth, screenResolutionHeight, resolution), rootStyle = _b.rootStyle, contentStyle = _b.contentStyle;
    var workarea = objects === null || objects === void 0 ? void 0 : objects.find(function (object) {
        return (0, seesignage_utils_1.isFabricWorkareaOptions)(object);
    });
    return (react_1.default.createElement("div", { id: 'content-root', style: rootStyle },
        react_1.default.createElement("div", { id: 'content-container', style: contentStyle },
            react_1.default.createElement(CanvasBackground_1.default, { content: content }),
            objects &&
                objects.map(function (obj) {
                    if ((0, seesignage_utils_1.isPlayerVideoObject)(obj)) {
                        return react_1.default.createElement(VideoElement_1.default, { key: obj.cId, object: obj });
                    }
                    else if ((0, seesignage_utils_1.isIframeObject)(obj)) {
                        return react_1.default.createElement(IframeElement_1.default, { key: obj.cId, object: obj });
                    }
                    else if ((0, seesignage_utils_1.isStopScheduleObject)(obj)) {
                        return react_1.default.createElement(StopScheduleElement_1.default, { key: obj.cId, object: obj });
                    }
                    else if ((0, seesignage_utils_1.isTableObject)(obj)) {
                        return react_1.default.createElement(TableElement_1.default, { key: obj.cId, object: obj });
                    }
                    else if ((0, seesignage_utils_1.isDateObject)(obj)) {
                        return react_1.default.createElement(DateElement_1.default, { key: obj.cId, object: obj });
                    }
                    else if ((0, seesignage_utils_1.isWeatherObject)(obj)) {
                        return react_1.default.createElement(WeatherElement_1.default, { key: obj.cId, object: obj });
                    }
                    else if ((0, seesignage_utils_1.isRssFeedObject)(obj)) {
                        return react_1.default.createElement(RssFeedElement_1.default, { key: obj.cId, object: obj });
                    }
                    else if ((0, seesignage_utils_1.isMediaCarouselObjectPlayer)(obj)) {
                        return react_1.default.createElement(MediaCarouselElement_1.default, { key: obj.cId, object: obj });
                    }
                    else if ((0, seesignage_utils_1.isQRCodeObject)(obj)) {
                        return react_1.default.createElement(QRCodeElement_1.default, { key: obj.cId, object: obj });
                    }
                    else if (workarea && (0, seesignage_utils_1.isFabricWidgetOptions)(obj)) {
                        return (react_1.default.createElement(PlayerWidgetContainer_1.default, { key: obj.customOptions.id, object: obj, workarea: workarea }, (0, seesignage_utils_1.isFabricDateOptions)(obj) ? (react_1.default.createElement(DateWidget_1.default, { dateProps: obj.customOptions.widgetProps })) : (0, seesignage_utils_1.isFabricIframeOptions)(obj) ? (react_1.default.createElement(IframeWidget_1.default, { iframeProps: obj.customOptions.widgetProps })) : (0, seesignage_utils_1.isFabricMediaCarouselOptions)(obj) ? (react_1.default.createElement(MediaCarouselWidget_1.default, { mediaCarouselProps: obj.customOptions.widgetProps, width: obj.width || 0, height: obj.height || 0 })) : (0, seesignage_utils_1.isFabricQRCodeOptions)(obj) ? (react_1.default.createElement(QRCodeWidget_1.default, { qrCodeProps: obj.customOptions.widgetProps })) : (0, seesignage_utils_1.isFabricRssFeedOptions)(obj) ? (react_1.default.createElement(RssFeedWidget_1.default, { rssFeedProps: obj.customOptions.widgetProps })) : (0, seesignage_utils_1.isFabricSocialMediaOptions)(obj) ? (react_1.default.createElement(SocialMediaWidget_1.default, { socialMediaProps: obj.customOptions.widgetProps })) : (0, seesignage_utils_1.isFabricStopScheduleOptions)(obj) ? (react_1.default.createElement(StopScheduleWidget_1.default, { stopProps: obj.customOptions.widgetProps, id: obj.customOptions.id })) : (0, seesignage_utils_1.isFabricTableOptions)(obj) ? (react_1.default.createElement(TableWidget_1.default, { tableProps: obj.customOptions.widgetProps })) : (0, seesignage_utils_1.isFabricVideoOptions)(obj) ? (react_1.default.createElement(VideoWidget_1.default, { videoProps: obj.customOptions.widgetProps })) : (0, seesignage_utils_1.isFabricWeatherOptions)(obj) ? (react_1.default.createElement(WeatherWidget_1.default, { weatherProps: obj.customOptions.widgetProps })) : (0, seesignage_utils_1.isFabricFalconyAnnouncementsOptions)(obj) ? (react_1.default.createElement(FalconyAnnouncementsWidget_1.default, { falconyAnnouncementsProps: obj.customOptions.widgetProps, widgetHeight: obj.height || 0, widgetWidth: obj.width || 0 })) : null));
                    }
                    else {
                        return null;
                    }
                }))));
};
exports.default = CanvasContent;
//# sourceMappingURL=CanvasContent.js.map